import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (project) => present(repository.getProjectExpenses(project));
}

export type { Interactor };

export { createInteractor };
